import React from 'react';
import ReactMarkdown from 'react-markdown';
import { TooltipRenderProps } from 'react-joyride';

export const TourTooltip: React.FC<TooltipRenderProps> = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep,
}) => {
  return (
    <div
      {...tooltipProps}
      className="tour-tooltip"
      style={{
        backgroundColor: 'hsl(var(--background))',
        borderRadius: '8px',
        padding: '20px',
        maxWidth: '420px',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
      }}
    >
      {/* Título */}
      {step.title && (
        <div
          className="tour-tooltip-title"
          style={{
            fontSize: '1.25rem',
            fontWeight: 600,
            marginBottom: '12px',
            color: 'hsl(var(--foreground))',
          }}
        >
          {step.title}
        </div>
      )}

      {/* Conteúdo com Markdown */}
      <div
        className="tour-tooltip-content"
        style={{
          fontSize: '0.95rem',
          lineHeight: 1.6,
          color: 'hsl(var(--foreground))',
          marginBottom: '16px',
        }}
      >
        <ReactMarkdown
          components={{
            // Customizar renderização de elementos
            p: ({ children }) => (
              <p style={{ margin: '0 0 8px 0' }}>{children}</p>
            ),
            strong: ({ children }) => (
              <strong style={{ fontWeight: 700, color: 'hsl(var(--primary))' }}>
                {children}
              </strong>
            ),
            em: ({ children }) => (
              <em style={{ fontStyle: 'italic' }}>{children}</em>
            ),
            ul: ({ children }) => (
              <ul style={{ marginLeft: '20px', marginBottom: '8px' }}>
                {children}
              </ul>
            ),
            li: ({ children }) => (
              <li style={{ marginBottom: '4px' }}>{children}</li>
            ),
          }}
        >
          {step.content as string}
        </ReactMarkdown>
      </div>

      {/* Footer com botões */}
      <div
        className="tour-tooltip-footer"
        style={{
          display: 'flex',
          gap: '8px',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {/* Botão Skip (à esquerda) */}
        {!isLastStep && (
          <button
            {...skipProps}
            style={{
              background: 'none',
              border: 'none',
              color: 'hsl(var(--muted-foreground))',
              cursor: 'pointer',
              fontSize: '0.875rem',
            }}
          >
            Pular
          </button>
        )}

        {/* Botões de navegação (à direita) */}
        <div style={{ display: 'flex', gap: '8px', marginLeft: 'auto' }}>
          {index > 0 && (
            <button
              {...backProps}
              style={{
                background: 'none',
                border: '1px solid hsl(var(--border))',
                padding: '8px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                color: 'hsl(var(--foreground))',
                fontSize: '0.875rem',
              }}
            >
              Voltar
            </button>
          )}

          {continuous && (
            <button
              {...primaryProps}
              style={{
                backgroundColor: 'hsl(var(--primary))',
                color: 'hsl(var(--primary-foreground))',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: 500,
                fontSize: '0.875rem',
              }}
            >
              {isLastStep ? 'Concluir' : 'Próximo'}
            </button>
          )}

          {!continuous && (
            <button
              {...closeProps}
              style={{
                backgroundColor: 'hsl(var(--primary))',
                color: 'hsl(var(--primary-foreground))',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: 500,
                fontSize: '0.875rem',
              }}
            >
              Fechar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
